import {IDS} from '../improvement-action-id.constants';
import {TYPES} from "../improvement-action-type.constants";
import * as Actions from '../improvement.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FETCH, GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import watch from "redux-watch";
import pick from "lodash/pick";
import {TAB_ENABLE, TAB_SELECT} from "../../../../common/tabs/tabs.constants";
import find from "lodash/find";
import {updateImprovementActionPlan} from "../improvement.actions";
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";

class ImprovementActionPlanController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $filter,
                $timeout,
                $transitions,
                $mdDialog,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoImprovement;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.isAdmin = user.type === 'Administrator';

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoImprovement;
            // this.maxDueDate = moment(`${maxYear}-01-01`).add(fiscalYearStart, 'months').subtract(1,'days').toDate();
            this.minDueDate = new Date();

            return {
                level1Requirements: subModule.level1Requirements,
                level3Requirements: subModule.level3Requirements,
                level3RequirementId: subModule.level3RequirementId,
                level3RequirementName: subModule.level3RequirementName,
                linkableEvidenceGroups: subModule.linkableEvidenceGroups,
                evidenceGroupId: subModule.evidenceGroupId,
                evidenceGroupName: subModule.evidenceGroupName,
                requirementsTree: state.accreditation.simpleSectionsTree,
                improvementAction: subModule.improvementAction,
                improvementSteps: get(subModule, `${IDS.improvementStepsGrid}.items`, []),
                improvementStep: subModule.improvementStep,
                stepDialog: subModule.stepDialog,
                fiscalYear: accDashboardLocationYear.year,
                alsoAssignImprovementAction: subModule.alsoAssignImprovementAction,
                firstDocType: state.accreditation.common.documentTypes[0].value,
            }
        }, {
            ...AccAction,
            ...Actions,
            ...this.FileActions,
        })(this);

        this.initRequirementsInputSelects();

        const ctrl = this;
        this.$timeout(function() {
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: TYPES.RESET_NEW_STEP_DETAILS,
            });
        }, 200);
    }

    async onAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.improvementAction.location_uuid,
            `${this.identifier}.${IDS.assigneeCandidates}`,
        );
    }

    async initRequirementsInputSelects () {
        const skipEmptyNodes = true;
        await this.fetchFrameworkRequirementsTree(this.schemeCode, this.improvementAction.location_uuid, this.fiscalYear, skipEmptyNodes);
        // insert requirements to first requirement select box
        this.$ngRedux.dispatch({
            type: TYPES.SELECT_NEW_STEP_REQUIREMENT,
            id: this.identifier,
            level:0,
            requirements: this.requirementsTree,
            requirementId: null,
            requirementParentId: null,
        });
        const selectedLevel1Id = get(this.requirementsTree, '[0].id');
        const selectedLevel2Id = get(this.requirementsTree,'[0].children[0].id');
        if(selectedLevel1Id)
            this.onSelectRequirement({item:{value: selectedLevel1Id}});
        if(selectedLevel2Id)
            this.onSelectRequirement({item:{value: selectedLevel2Id}});

        // if(this.preselectedRequirement && this.siteLocation){
        //     this.requirementId = this.preselectedRequirement;
        //     this.preselectedRequirement = null;
        //     this.onButtonAssignRequirement()
        // }
    }

    onSelectRequirement({item}){
        const requirement = this.findChildRequirementById(item.value, this.requirementsTree);
        this.$ngRedux.dispatch({
            type:               TYPES.SELECT_NEW_STEP_REQUIREMENT,
            id:                 this.identifier,
            level:              requirement.level,
            requirements:       requirement.children,
            name:               requirement.name,
            requirementId:      requirement.id,
            requirementParentId:requirement.parentId,
        });
        if(requirement.level === 3) {
            this.fetchRequirementEvidenceGroups(requirement.id, this.improvementAction.location_uuid, this.schemeCode);
        }
    }

    findChildRequirementById(id, requirements) {
        return requirements.reduce((result, item) => {
            if(result)
                return result;
            if(item.id === id)
                return item
            else if (item.children.length)
                return this.findChildRequirementById(id, item.children)
        }, null);
    }

    onResetRequirement() {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_REQUIREMENT
        });
        this.onResetEvidenceGroup();
        this.onResetLinkableEvidenceGroups();
    }

    onSelectEvidenceGroup($event) {
        // this.evidenceGroupName;
    }

    onResetEvidenceGroup() {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_SELECTED_EVIDENCE_GROUP
        });
    }

    onResetLinkableEvidenceGroups() {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_LINKABLE_EVIDENCE_GROUPS
        });
    }

    onAddActionTask = () => {
        // verify limit of 100 steps is not reached
        if (this.improvementSteps.length === 100)
            return

        const form = this.$scope.addActionStepForm;
        // verify fields
        if(form.$invalid) {
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            return;
        }

        // verify that title is unique
        if(this.improvementSteps.some(step => step.name === this.improvementStep.title)) {
            this.Notifier.error('Action task title already exists');
            return;
        }

        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: this.identifier,
            path: IDS.improvementStepsGrid,
            items: [
                {
                    task_number:    '***',
                    assignee:       this.improvementStep.assignee.name,
                    assignee_uuid:  this.improvementStep.assignee.subject_uuid,
                    name:           this.improvementStep.title,
                    description:    this.improvementStep.description,
                    requirement_id: this.level3RequirementId,
                    requirement_name: this.level3RequirementName || '-',
                    evidence_id:    this.evidenceGroupId,
                    evidence_name:  this.evidenceGroupName || '-',
                    due_date:       formatDate(this.improvementStep.due_date, DATE_FORMAT.OUTPUT),
                    status_name:    'Not Saved',
                },
                ...this.improvementSteps
            ],
        });
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_NEW_STEP_DETAILS,
        });
        form.$setPristine();
        form.$setUntouched();
        form.action_task_title.$setPristine();
        form.action_task_title.$setUntouched();
        form.action_task_description.$setPristine();
        form.action_task_description.$setUntouched();
        form.action_task_date.$setPristine();
        form.action_task_date.$setUntouched();
        form.assigneeCandidateAutocomplete.$setPristine();
        form.assigneeCandidateAutocomplete.$setUntouched();
        window.scrollTo(0, document.body.scrollHeight);
    }

    onGridButtonRemoveTask = ({item}) => {
        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: this.identifier,
            path: IDS.improvementStepsGrid,
            items: [...this.improvementSteps.filter(step => step !== item)]
        });
    }

    onSelectImprovementStep = ({item}) => {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.SELECT_STEP,
            details: item,
            firstDocType: this.firstDocType,
        });
        this.$ngRedux.dispatch({
            type: TAB_ENABLE,
            id: IDS.app_accreditation_scheme_improvement,
            state: [
                IDS.app_accreditation_scheme_improvement_step,
            ]
        });
        const improvementAction = this.improvementAction;
        const {identifier} = this;
        this.$timeout(() => {
            this.$ngRedux.dispatch({
                type: TAB_SELECT,
                id: IDS.app_accreditation_scheme_improvement,
                state: IDS.app_accreditation_scheme_improvement_step,
                stateParams: {
                    action_id: improvementAction.uta_id,
                    step_id: item.uta_id
                },
            });
            // if is Evidence review or Document revision or Improvement step with evidence
            if(item.ard_id) {
                this.$timeout(() => {
                    this.$ngRedux.dispatch({
                        type: GRID_FILTER,
                        id: identifier,
                        path: IDS.rcoEvidenceGroupDocumentsGrid,
                        filter: {
                            identifier,
                            evidence_group: item.ard_id,
                            requirement:    JSON.parse(item.requirements)[0]?.ase_id,
                            // fiscal_year:    item.fiscal_year,
                            slo_uuid:       item.location_uuid,
                        }
                    });
                });
            }
        });
    }


    onSubmit() {
        if(!this.improvementSteps?.length) {
            this.Notifier.error('Please add at least one task');
            return;
        }
        this.updateImprovementActionPlan({
            task_id:        this.improvementAction?.uta_id,
            action_steps:   this.improvementSteps.map(step => ({
                task_id:        step.uta_id,
                assignee:       step.assignee_uuid,
                title:          step.name,
                description:    step.description,
                requirement_id: step.requirement_id,
                evidence_id:    step.evidence_id,
                due_date:       step.due_date,
            })),
        }).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.improvementStepsGrid,
            });

            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.improvementActionsGrid,
            });
        });
    }

    onCancel() {
        this.$ngRedux.dispatch({
            type: TAB_SELECT,
            id: IDS.app_accreditation_scheme_improvement,
            state: IDS.app_accreditation_scheme_improvement_list,
        });
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
        if(this.unsubscribeLocationChange)
            this.unsubscribeLocationChange();
        if(this.unsubscribeLocationNotFound)
            this.unsubscribeLocationNotFound();
    }
}

ImprovementActionPlanController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$filter',
    '$timeout',
    '$transitions',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$scope']

export const improvementActionPlan = {
    controller: ImprovementActionPlanController,
    template: require('./action-plan.html')
}
